import getUserConfiguration from '../actions/getUserConfiguration';

export default function isUserCultureRightToLeft(): boolean {
    const userConfiguration = getUserConfiguration();
    return (
        userConfiguration.SessionSettings &&
        userConfiguration.SessionSettings.IsUserCultureRightToLeft
    );
}
